import { USERNAME_FORMAT_CODE, USER_ACTIVATION_METHOD } from '../../domain/domainCodes.js'
/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const common = {
  save: 'Save',
  saveFailed: 'Could not save, please try again',
  notAvailable: 'This setting is not available yet',
  reset: 'Cancel',
  update: 'Update',
  active: 'Enabled',
  inactive: 'Disabled',
  show: 'Show',
  hide: 'Hide',
  yes: 'Yes',
  no: 'No',
  arabic: 'Arabic Text',
  english: 'English Text',
  status: 'Status',
  none: 'None',
  saved: 'Saved successfully',
}

export const settingsStrings = {
  title: 'Application Settings',

  theme: {
    title: 'Visual identity',
    hint: 'Two colors set the look of the whole platform.',
    main: 'Primary color',
    mainHint: 'Buttons and the side menu',
    active: 'Selection color',
    activeHint: 'The marker on the current page',
    preview: 'Preview',
    mainContrast: 'Text on buttons',
    activeContrast: 'Selection on the menu',
    pass: 'Good',
    weak: 'Weak',
    restore: 'Default',
    save: 'Save',
    saved: 'Operation Completed Successfully',
  },

  tabs: {
    media: 'Chapter files',
    keys: 'Application Title',
    contact: 'Contact Page',
    video: 'Video Settings',
    userManual: 'User Manual',
    reports: 'Reports Settings',
    notifications: 'Notifications Settings',
    messaging: 'Messaging channels',
    email: 'Email settings',
  },

  email: {
    title: 'Email SMTP Settings',
    host: 'Host',
    port: 'Port',
    portHint: 'The port number used to connect to SMTP (usually 587 or 465).',
    from: 'Sender Email',
    fromHint: 'The address that is actually used as the SMTP Envelope (MAIL FROM).',
    senderName: 'Sender Name',
    username: 'Username',
    password: 'Password',
    ssl: 'Encryption options',
    serviceState: 'Service state',
    skipCertCheck: 'Skip server certificate validation',
    test: 'Test Email Sending',
    testHint: 'Sent with the values in the form right now, before they are saved.',
    testTitle: 'Test email sending',
    testAddress: 'Email address for testing',
    testAddressHint: 'The test message is delivered to this address',
    testSend: 'Send'
  },

  messaging: {
    whatsapp: 'Whatsapp',
    slack: 'Slack',
    sms: 'SMS',
    enabled: 'Enabled',
    apiUrl: 'Api Url',
    apiKey: 'Api Key',
    senderNumber: 'Sender number',
    senderId: 'Sender id',
    webhookUrl: 'Webhook URL',
    botToken: 'Bot token',
    channel: 'Channel',
  },

  servicesUrl: {
    title: 'Services URL',
    label: 'Services URL',
  },

  media: {
    whiteLogo: 'White Logo',
    whiteLogoHint:
      'This logo is used in the admin panel, the user panel and the video page. A white logo on a transparent background works best. If you do not have a white version, upload the standard one and switch the logo background to "Show" so it is framed and renders correctly across the site.',
    whiteLogoSpec: 'PNG (590 X 345)',
    logoBackground: 'Logo background',
    mainLogo: 'Main Logo',
    mainLogoHint:
      'This logo is used on the login page, in exported reports and on the policies page, and it also appears when the user panel is scrolled down or the main menu color is changed.',
    sideImage: 'Login Side Image',
    sideImageSpec: 'PNG (792 X 1200)',
    arabicImage: 'Arabic Image',
    englishImage: 'English Image',
    loginAndLogo: 'Login page & logo',
    loginTheme: 'Login Theme',
    white: 'White',
    black: 'Black',
    logoOnLogin: 'Logo on the login page',
    background: 'Login Background Image',
    backgroundSpec: 'JPG (2048 X 1365)',
    imageAr: 'Arabic image',
    imageEn: 'English image',
    favicon: 'Browser Icon',
    faviconSpec: 'PNG (48 X 48)',
  },

  keys: {
    appTitle: 'Application Title',
    arabicAppTitle: 'Arabic Application Title',
    englishAppTitle: 'English Application Title',
    footer: 'Website Footer Text',
    footerAr: 'Website Footer Text (Arabic)',
    footerEn: 'Website Footer Text (English)',
    organization: 'Organization Data',
    arabicOrgName: 'Arabic Organization Name',
    englishOrgName: 'English Organization Name',
    orgEmail: 'Organization Email',
    orgEmailHint:
      'This email is used to alert the system administrator of a new cyber incidents. It must be associated with a user registered in the system and own system administrator privileges. you can put comma separated (,) multiple emails here. make sure the emails are linked with users.',
    domain: 'Domain URL',
    domainNote: '(Used in notifications)',
    domainSpec: 'https://www.Website-Name.com',
    useHsts: 'Enforce secure connection via HTTPS (HSTS)',
  },

  contact: {
    title: 'Contact Page',
    allDisabledWarning: 'Warning, all elements are disabled, please make sure to enable at least on element!',
    enablePage: 'Show Support Contact Info Page',
    pageTitle: 'Page Title',
    pageHeader: 'Page Header Text',
    enableEmail: 'Enable Email',
    emailAddress: 'Email Address',
    emailOptions: 'Display Email Options',
    showSendForm: 'Show send email form',
    showEmailInfo: 'Display email information',
    emailLabel: 'Email Label Text',
    showPhone: 'Show Phone Number',
    phone: 'Telephone',
    phoneLabel: 'Phone Label Text',
  },

  video: {
    title: 'Video Settings',
    progressBar: 'Enable Progress bar',
    progressBarHint:
      'Enable this option to allow users to move forward or backward within the video (seek). This is useful for long videos where viewers may want to skip or revisit certain sections.',
    forceSubtitle: 'Enable Force Subtitle',
    forceSubtitleHint:
      'Enable this option to always display subtitles when the video plays, regardless of the viewer’s settings. This is useful for accessibility or when the video has non-native language content.',
    userSubtitleControl: 'Allow users to toggle subtitles on or off during playback.',
    pauseOnBlur: 'Stop video playing when window loses focus',
    pauseOnBlurHint:
      'Enable this option to automatically pause the video when the user switches to another browser tab or navigates away from the current page. This ensures the viewer doesn’t miss any part of the content.',
    playbackRates: 'Enable playback rates',
    playbackRatesHint:
      'Enable this option to let users adjust the video playback speed (e.g., slower or faster). This is useful for learning, reviewing, or skimming through content at a comfortable pace.',
  },

  userManual: {
    guide: 'User Manual',
    guideAr: 'Arabic user manual',
    guideEn: 'English user manual',
    settings: 'User Guide Settings',
    popup: 'Show user manual upon entry in a popup window',
    introVideo: 'Show a video instead of a user manual',
    linkOnLogin: 'Show the user guide link on the login page',
    separatePage: 'Show the user guide on a separate page',
    adminUrl: 'Admin Panel User Manual URL',
  },

  reports: {
    title: 'Reports Settings',
    userStatistics: 'Enable statistics page for user',
    policiesColumns: 'Profile Data on Policies Report',
    examsColumns: 'Profile Data on Exams Report & Programs Report',
  },

  notifications: {
    title: 'Notifications Settings',
    email: 'Email',
    index: '#',
    name: 'Name',
    lastUpdated: 'Last Updated',
    edit: 'Update',
    autoDays: 'Days between automatic notifications',
  },

  autoDaysTypes: [1, 2, 3, 5, 12, 13],

  templatelessTypes: [6, 7, 14],

  profileAttributes: [
    { name: 'Username', label: 'Username' },
    { name: 'Fullname', label: 'Full name' },
    { name: 'Email', label: 'Email' },
    { name: 'Department', label: 'Group' },
    { name: 'Gender', label: 'Gender' },
    { name: 'EmployeeId', label: 'Employee Id' },

    { name: 'Attribute1', setting: 'Attribute1_AR_Name' },
    { name: 'Attribute2', setting: 'Attribute2_AR_Name' },
    { name: 'Attribute3', setting: 'Attribute3_AR_Name' },
    { name: 'Attribute4', setting: 'Attribute4_AR_Name' },
    { name: 'Attribute5', setting: 'Attribute5_AR_Name' },
  ],
}

export const advancedStrings = {
  title: 'Advanced Settings',

  tabs: {
    login: 'Login Settings',
    profile: 'User Profile Settings',
    sources: 'Data Sources Settings',
    sync: 'Data Sync Settings',
    registration: 'Manual Registration Settings',
    servers: 'Multi Server Settings',
    services: 'Services Settings',
  },

  login: {
    general: 'General Settings',
    generalSubtitle: 'Applies to fields on the profile page',
    licenseType: 'License Method',
    authMethod: 'Authentication Method',
    authSource: 'Authentication Source',
    loginPage: 'Login Page',
    ldapSso: 'LDAP SSO',
    usernameFormat: 'When an email address is used as the username during the login process',
    usernameFormatOptions: [
      { value: USERNAME_FORMAT_CODE.UNCHANGED, label: 'Do Nothing' },
      {
        value: USERNAME_FORMAT_CODE.EXTRACT_USERNAME,
        label:
          'Extract the username component from the email address (for example, user123@example.com would yield user123) and use it for login',
      },
      {
        value: USERNAME_FORMAT_CODE.REJECT_EMAIL,
        label:
          'Stop the login process and inform the user to use only their username instead of their full email address.',
      },
    ],

    otp: 'One Time Password',
    otpEnabled: 'One Time Password Enabled',
    otpTarget: 'Targeted Groups',
    otpTargets: [
      { value: 'Admins', label: 'Admins Only' },
      { value: 'Users', label: 'Users Only' },
      { value: 'All', label: 'Select All' },
    ],
    otpLength: 'One Time Password Length',
    otpValidPeriod: 'One Time Password Valid Period (Seconds)',

    lockout: 'Account Lockout Settings',
    lockoutEnabled: 'Enable Account Lockout When Wrong Password Entry',
    attempts: 'Attempts Before Lockout',
    lockoutWindow: 'Account Lockout Period in Minutes',
    sessionTimeout: 'Session Timeout In Minutes',

    terms: 'Terms of Use Settings',
    termsAr: 'Arabic Terms of Use',
    termsEn: 'English Terms of Use',
    termsEnable: 'Enable Terms of Use page',
    termsEnableNote:
      '(Checking this will prevent user from using the system until he agrees upon the terms of use)',
    termsUpdated:
      'Update terms of use and force users to consent first before continuing to use the system',
    termsUpdatedNote: '(Select this option in case this is an update to the terms of use.)',
    termsSubmit: 'Save',
  },

  profile: {
    title: 'Profile Mapping',
    chooseCompany: 'Choose company',
    fieldsHeading: 'Select which field should appeare in the user profile page',
    allowEdit: 'Allow Update by User',

    fields: [
      { name: 'EnglishName', label: 'English Name' },
      { name: 'ArabicName', label: 'Arabic Name' },
      { name: 'Gender', label: 'Gender' },
      { name: 'Email', label: 'Email' },
      { name: 'Phone', label: 'Phone' },
      { name: 'Mobile', label: 'Mobile' },
      { name: 'DepartmentId', label: 'Group' },
      { name: 'EmployeeId', label: 'Employee Id' },
      { name: 'Username', label: 'Username' },

      { name: 'Attribute1', setting: 'Attribute1_AR_Name' },
      { name: 'Attribute2', setting: 'Attribute2_AR_Name' },
      { name: 'Attribute3', setting: 'Attribute3_AR_Name' },
      { name: 'Attribute4', setting: 'Attribute4_AR_Name' },
      { name: 'Attribute5', setting: 'Attribute5_AR_Name' },
    ],

    lockedEditIndex: 8,

    customAttributes: 'Custom Profile Attributes Names',
    attribute: 'Attribute',
    arabicName: 'Arabic Name:',
    englishName: 'English Name:',

    otherProperties: 'Other Properties',
    allowEditPageTitle: 'Do you want to redirect user after first loing to edit profile page?',
    allowEditPage: 'Yes, redirect to update profile page',
    forceGroupLabel: 'Force Group Change for Current User Group',
    forceGroupCheck: 'Enable force groups change for specific group if user is present in this group',
    forceGroupSelect: 'Users Groups',
  },

  sources: {
    title: 'Data Sources Settings',
    newSource: 'New Source',
    name: 'Source name',
    type: 'Type',
    arabicName: 'Arabic Name:',
    englishName: 'English Name:',
    username: 'Username',
    connectionString: 'Connection String',
    isActive: 'Active',
    edit: 'Update',
    domain: 'Directory domain',
    tenantId: 'Microsoft Entra tenant ID or verified domain',
    clientId: 'Application (client) ID',
    clientSecret: 'Client secret',
    password: 'Bind password',
    secretUnchanged: 'Leave blank to keep the stored credential.',
    graphEndpoint: 'Microsoft Graph endpoint',
    odataFilter: 'Optional Microsoft Graph user filter',
    ldapFilter: 'LDAP user search filter',
    accessGroup: 'Allowed access group ID or name (optional)',
    adminGroups: 'Rawam administrator group IDs or names (optional)',
    groupsNote: 'Separate multiple groups with semicolons.',
    entraPrerequisites: 'Register a Web application in Microsoft Entra ID with this Rawam website /signin-entra URL as its redirect URI. Grant Microsoft Graph application permission User.Read.All with administrator consent; also grant GroupMember.Read.All when access or administrator groups are configured.',
    ssl: 'Use secure LDAP (LDAPS)',
    test: 'Test connection',
  },

  sync: {
    title: 'Data Sync Settings',
    deptsSource: 'Departments Integration Data Source',
    usersSource: 'All Users Integration Data Source',
    userFetchSource: 'User Fetch Integration Data Source',
    sourceOptions: [
      { value: 'WebAPI', label: 'WebAPI' },
      { value: 'ActiveDirectory', label: 'ActiveDirectory' },
      { value: 'None', label: 'None' },
    ],
    deptsType: 'Departments Integration Type',
    usersType: 'Users Integration Type',
    userFetchType: 'User Fetch Integration Type',
    import: 'Import',
    syncOnly: 'Sync',
    importSync: 'ImportSync',

    autoTitle: 'Auto Sync Settings',
    deptsAutoFetch: 'Departments Auto Fetch',
    usersAutoFetch: 'Users Auto Fetch',
    delay: 'Delay Before Next Run',
    overLicense: 'When Fetched Users Count Greater Than License',
    overLicenseOptions: [
      { value: 'Reject', label: 'Reject Fetch Operation' },
      { value: 'AsLicenseCount', label: 'Take As License Count' },
    ],
    deleteEmptyGroups: 'Delete Active Directory Groups With No Users',
    commandMode: 'How the synced profiles are written to the database',
    commandModeOptions: [
      { value: 'bulkSql', label: 'SQL' },
      { value: 'bulkEF', label: 'ORM' },
    ],
  },

  registration: {
    title: 'Manual Registration Settings',
    activateInvitations: 'Activate Invitations Module',
    showRegistrationLink: 'Activate the manual registration feature in the system',
    activateResetPassword: 'Activate forget password feature in the system',
    activationMethod: 'Account activation method',
    activationOptions: [
      { value: String(USER_ACTIVATION_METHOD.EMAIL), label: 'Automatic' },
      { value: String(USER_ACTIVATION_METHOD.ADMIN), label: 'Manual By Admin' },
    ],
    emailOnDomain: 'Email Should be on Domain',
    domains: 'Company Domain',
    copyLink: 'Copy Registration Link',
    registerLink: 'Registration',
    noteTitle: 'Note on manual registration',
    noteBody:
      'After the user registers, an email will be sent to the user to verify the validity of the email, after which the account will be activated based on the specified activation method',
  },

  servers: {
    title: 'Multi Server Settings',
    newServer: 'New Server',
    serverId: 'Server ID',
    serverUrl: 'Server URL',
    edit: 'Update',
  },

  services: {
    title: 'Services Settings',
    notifications: 'Notifications',
    phishing: 'Phishing',
    sync: 'Sync',
    emailSettings: 'Email Service Settings',
    enableNotificationService: 'Enable the notifications service',
    enableNotificationServiceHint: 'Enable the service',
    maxRetries: 'Maximum Retry Attempts',
    maxRetriesHint: 'Messages are retried until they reach the maximum number of attempts.',
    maxTaskMinutes: 'Maximum Notification Sending Duration',
    maxTaskMinutesHint:
      'The longest a job may take (in minutes) to process an email. This stops two jobs working the same message at once.',
    statusHintNotifications: 'Enable the service — required by the notifications service',
    statusHint: 'Enable the service',
    delayHint: 'How long to wait before the service runs again',
    logs: 'Console Logs',
    logsHint: 'Write the service log',
    maxProcessed: 'Maximum Entries to Process',
    maxProcessedHint: 'The maximum number of jobs the service may pick up in a single run.',
    maxParallelism: 'Maximum Parallel Tasks',
    maxParallelismHint: 'The maximum number of jobs the service may run at the same time.',

    groups: [
      {
        id: 'notifications',
        items: [
          { id: 'NotificationsCreation', name: 'Notifications Creation', maxProcessed: true },
          {
            id: 'NotificationsSending',
            name: 'Notifications Sending',
            maxProcessed: true,
            maxParallelism: true,
          },
          { id: 'MarkFailedNotifications', name: 'Mark Failed Notifications' },
        ],
      },
      {
        id: 'phishing',
        items: [
          { id: 'Phishing', name: 'Phishing' },
          { id: 'EmailListener', name: 'Email Listener' },
        ],
      },
      {
        id: 'sync',
        items: [
          { id: 'SyncDepts', name: 'Departments Auto Fetch' },
          { id: 'SyncUsers', name: 'Users Auto Fetch' },
        ],
      },
    ],
  },
}

export const settingsKeysStrings = {
  reference: {
    title: 'Reference data',
    status: 'Status',
    present: 'Present',
    missing: 'Not Found',
    group: 'Group',
    id: 'Id',
    enumName: 'Code name',
    dbName: 'Database name',
    ffmpeg: 'Video processing tool (ffmpeg)',
    groups: {
      activities: 'Activity types',
      groupTypes: 'Group types',
      difficultyLevels: 'Difficulty levels',
      courseLevels: 'Course levels',
      authMethods: 'Authentication methods',
      templates: 'Notification templates',
    },
  },
  title: 'Settings Values',
  databaseValue: 'Database Value',
  defaultValue: 'Default Value',
  none: 'None',
  key: 'Key',
}
